"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpacingIconTypes = void 0;
var SpacingIconTypes = {
  EMBED: 'embed',
  IMAGE: 'image',
  VIDEO: 'video'
};
exports.SpacingIconTypes = SpacingIconTypes;